import { render, staticRenderFns } from "./reset-pass.vue?vue&type=template&id=71054b36"
import script from "./reset-pass.vue?vue&type=script&lang=js"
export * from "./reset-pass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71054b36')) {
      api.createRecord('71054b36', component.options)
    } else {
      api.reload('71054b36', component.options)
    }
    module.hot.accept("./reset-pass.vue?vue&type=template&id=71054b36", function () {
      api.rerender('71054b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/account/reset-pass.vue"
export default component.exports